// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"553":"12c5442b","977":"d8f41727"}[chunkId] + ".chunk.js";
};